


































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import EventContactPromoterModalComponent from '@/components/Events/EventContactPromoterModalComponent.vue';
import TicketCheckout from '@/components/TicketCheckout.vue';
import EventDTO from '@/api/dto/EventDTO';
import EventModel from '@/api/model/EventModel';
import ITier from '@/api/interface/ITier';
import SponsorDTO from '@/api/dto/SponsorDTO';
import ApiUtils from '@/api/util/ApiUtils';
import TypeUtils from '@/api/util/TypeUtils';
import TicketDefinitionDTO from '@/api/dto/TicketDefinitionDTO';
import DonationEmbed from '@/components/DonationEmbed.vue';
import MapComponent from '@/components/Widgets/MapComponent.vue';
import FormatUtils from '@/api/util/FormatUtils';
import BaseVue from '@/api/core/BaseVue';
import EventDate from '@/components/EventDate.vue';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import { formatToTimeZone } from 'date-fns-timezone';

@Component({
  components: {
    EventContactPromoterModalComponent,
    TicketCheckout,
    DonationEmbed,
    MapComponent,
    EventDate,
  },
})
export default class TemplateOne extends BaseVue {
  @Prop(Object) public event!: any;
  @Prop(Array) public tiers!: ITier[];
  @Prop(Boolean) public readonly isEventInactive!: boolean;
  @Prop(String) public readonly posterVideoURL!: string;

  public order: any;
  public tickets: any;

  public $refs!: {
    modal: any;
  };

  public formatDates(firstDate, secondDate, timezone) {
    secondDate = secondDate || '';
    timezone = timezone || 'UTC';

    const startTime = formatToTimeZone(new Date(firstDate), 'hh:mm a', {
      timeZone: timezone,
    });

    const endTime = formatToTimeZone(new Date(secondDate), 'hh:mm a (z)', {
      timeZone: timezone,
    });

    const startDate = format(new Date(firstDate), 'eee, MMM d');
    const endDate = format(new Date(secondDate), 'eee, MMM d, yyyy');

    if (isSameDay(new Date(firstDate), new Date(secondDate))) {
      return `${startDate} ${startTime} - ${endTime}`;
    }

    return `${startDate} ${startTime} - ${endDate} ${endTime}`;
  }

  private tryHide(event) {
    switch (event.trigger) {
      case 'esc':
      case 'backdrop':
        event.preventDefault();
        break;
      default:
        break;
    }
  }

  private closeCheckout() {
    this.$refs.modal.hide();
  }

  private formatPrice(price) {
    return TypeUtils.toFloat(price) === 0
      ? 'Free'
      : FormatUtils.formatCurrency(price, this.event.currencyCode);
  }

  private clickTickets() {
    this.$bvModal.show('register-event-tickets-modal');
  }
}
